import { createFileRoute } from "@tanstack/react-router";
import {
  loadBannerList,
  loadGameCategoryList,
  loadGameList,
  loadProviderList,
  loadRecommendedGames,
} from "app/lib/loaders";
import { HomePage } from "pages/home";

export const Route = createFileRoute("/_auth/casino")({
  loader: () =>
    Promise.all([
      loadBannerList(),
      loadGameCategoryList(),
      loadGameList(),
      loadProviderList(),
      loadRecommendedGames(),
    ]),
  component: HomePage,
  onError: console.error,
});
